import Button from "pages/_components/Button";
import Notification from "pages/_components/Notification";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import ResponsiveHeader, { DesktopButtons, MobileButtons } from "pages/_components/header";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import Action from "pages/_components/Action";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import LoadRequest from "./LoadRequest";
import { actions as accountsActions } from "reducers/accounts";
import * as i18n from "util/i18n";
import DownloadList from "./DownloadList";
import { useHistory, useLocation } from "react-router-dom";

const FORM_ID = "directDebit";
const DirectDebitLoadFile = (props) => {
    const dispatch = useDispatch();
    const { state } = useLocation();

    const { isDesktop } = props;

    const handleDownload = () => {
        dispatch(accountsActions.downloadTemplate());
    };  

    const initialTab = 0;
    
    const tabsData = [
        {
            text: `${FORM_ID}.loadRequest.title`,
            textType: "I18N",
        },
        {
            text:`${FORM_ID}.myrequests.title`,
            textType: "I18N",
        },
    ];

    useEffect(() => {
         if (!state)
            dispatch(accountsActions.directDebitClean());
    }, []);

    return (
        <>
            <Notification scopeToShow="DirectDebitNotification" />
            <ResponsiveHeader backLinkTo="/desktop" defaultTitle={i18n.get(`${FORM_ID}.title`)}>
                <DesktopButtons>
                    <Button className="btn btn-outline btn-block small" onClick={handleDownload}>
                        <Image
                            src={"images/figma/icon/download.svg"}
                            className="icon-medium svg-icon"
                        />
                        <I18n id={`${FORM_ID}.exampleTemplate.label`} />
                    </Button>
                </DesktopButtons>
                <MobileButtons>
                    <Action labelKey={`${FORM_ID}.exampleTemplate.label`} handleClick={handleDownload}/>
                </MobileButtons>
            </ResponsiveHeader>

            <MainContainer>
                <CustomTabs tabsData={tabsData} tab={initialTab}>
                    <LoadRequest/>
                    <DownloadList isDesktop={isDesktop} />
                </CustomTabs>
            </MainContainer>
        </>
    );
};

export default DirectDebitLoadFile;
